import { navigate } from 'gatsby';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';

import FlexColToRow from '@ui/molecules/FlexColToRow';

import aligned from '@ui/styled/Aligned';
import fullWidth from '@ui/styled/FullWidth';
import visible from '@ui/styled/Visible';

import { CardContent } from '@folx-types/dashboard';

import IconArrow from '@assets/vectors/icon-arrow.inline.svg';

import theme from '@theme/FolxTheme';

interface IDashboardCardLinkProps extends CardContent {
	variant?: 'default' | 'minimal';
}

const AlignedColumn = aligned<IFlexColumn>(fullWidth<IFlexColumn>(FlexColumn));
const MobileArrow = aligned(visible(IconArrow as unknown as ReactNode));

const DashboardCard = styled.button`
	background: ${theme.colors.white};
	border-radius: ${theme.radius.xl};
	padding: ${theme.spacing.md} 1.4rem;
	cursor: pointer;
	height: 100%;
	text-align: start;

	&:hover,
	&:focus-visible {
		box-shadow: ${theme.shadow.hoverBox};
	}
`;

const DashboardCardLink: FC<IDashboardCardLinkProps> = ({
	description,
	external,
	header,
	Icon,
	pathName,
	variant = 'default',
}) => {
	return (
		<DashboardCard onClick={() => (external ? window?.open(pathName) : navigate(pathName))}>
			<FlexColToRow
				initialLayout="row"
				breakpoint={variant === 'minimal' ? 'mobileS' : 'tablet'}
				gap="xs">
				<Icon
					style={{
						flexShrink: 0,
						height: '5rem',
						width: '5rem',
						...(variant === 'minimal' ? { margin: '0 auto' } : {}),
					}}
				/>
				<AlignedColumn gap="xs" alignItems={variant === 'minimal' ? 'center' : 'flex-start'}>
					<SubheadingText>{header}</SubheadingText>
					{variant === 'default' && <BasicText variant="fineprint">{description}</BasicText>}
				</AlignedColumn>
				{variant === 'default' && (
					<MobileArrow defaultVisible breakpoint="tablet" alignSelf="center" width="3rem" />
				)}
			</FlexColToRow>
		</DashboardCard>
	);
};

export default styled(DashboardCardLink)``;
